import React from 'react';
import { Link, NavLink } from 'react-router-dom';

import HeaderTopbar from '../HeaderTopbar';
import MobileMenu from '../MobileMenu';
import Logo from '../../images/lhcf_logo.jpeg';
import './style.css';

const Header = () => {
  return (
    <div className="middle-header header-style-3">
      <HeaderTopbar />
      <div className="container">
        <div className="header-content">
          <div className="row d-flex justify-content-between">
            <div className="col-lg-3 col-md-4 col-sm-4 col-4">
              <div className="logo">
                <Link to="/" title="">
                  <img src={Logo} alt="" />
                </Link>
              </div>
            </div>
            <div className="col-lg-9 d-lg-block d-none">
              <nav>
                <ul>
                  <li>
                    <NavLink to="/" title="" exact={true}>
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/about" title="">
                      About
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/gallery" title="">
                      Gallery
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/publications" title="">
                      Publications
                    </NavLink>
                  </li>
                  <li>
                    <p>Activities</p>
                    <ul>
                      <li>
                        <NavLink to="/events" title="">
                          Events
                        </NavLink>
                      </li>
                      <li>
                        <Link to="/donate" title="">
                          Donate
                        </Link>
                      </li>
                      <li>
                        <Link to="/volunteer" title="">
                          Volunteer
                        </Link>
                      </li>
                      <li>
                        <Link to="/sponsored-children" title="">
                          Sponsor a Child
                        </Link>
                      </li>
                      <li>
                        <Link to="/blog" title="">
                          Blog
                        </Link>
                      </li>
                    </ul>
                  </li>
                  {/* TODO: RE-ENABLE THE PAGE ONCE THERE IS A PUBLISHED ARTICLE FROM LHCF */}
                  {/* <li>
                    <NavLink to="/blog">Blog</NavLink>
                  </li> */}
                  <li>
                    <NavLink to="/contact" title="">
                      Contact
                    </NavLink>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="col-md-8 col-sm-2 col-8">
              <MobileMenu />
            </div>
          </div>

          <div className="clearfix"></div>
        </div>
      </div>
    </div>
  );
};

export default Header;
